export default __webpack_public_path__ + "static/media/csharp-plain.bfd48d6c.svg";